<template>
  <div class="ticketing-service">
    <div class="page-header-banner">
      <div class="banner-main-content">
        <h1>报名参会</h1>
        <p>LIVE SUBSCRIPTION</p>
      </div>
    </div>
    <div class="ticket-part">
      <div class="buyer-list">
        <div class="common-info attendee-info">
          <div class="info-title" style="padding-left: 19px">
            参会者信息
          </div>
          <h-form
            ref="formDynamic"
            :model="formDynamic"
            label-position="top"
            class="common-info"
            :rules="ruleValidate"
            cols="2"
          >
            <h-form-item label="姓名" prop="name" cols="2">
              <h-input v-model="formDynamic.name"></h-input>
            </h-form-item>

            <h-form-item label="手机" prop="mobile" cols="1">
              <h-input v-model="formDynamic.mobile"></h-input>
            </h-form-item>
            <h-form-item label="公司/单位" prop="company" cols="1">
              <h-input v-model="formDynamic.company"></h-input>
            </h-form-item>
            <h-form-item prop="area_list" :required="false" cols="2">
              您要预约的分论坛(可选)
              <h-table
                stripe
                :columns="columns"
                :data="tableData"
                @on-selection-change="selectChange"
              ></h-table>
            </h-form-item>
          </h-form>

          <div class="submit-btn" @click="submitPay()">立即报名</div>
        </div>
      </div>
    </div>
    <!-- 光子提示 -->
    <ScanToAnswer :show="lightShow" :photonNum="photonNum" @close="onClose" />
  </div>
</template>
<script>
import { onlineSignup, checkLogin } from "@/api/developerConference.js";
import store from "@/store";
import { mapGetters } from "vuex";
import QRCode from "qrcode"; // 生成二维码插件
import axios from "axios";
import ScanToAnswer from "@/components/pnoton";
export default {
  components: {
    ScanToAnswer
  },
  data() {
    const validateContent = (rule, value, callback) => {
      value = value.replace(/\s+/g, "");
      if (!value) {
        return callback(new Error("输入不能为空"));
      } else {
        callback();
      }
    };
    const validateInfo = (rule, value, callback) => {
      value = value.replace(/\s+/g, "");
      if (!value) {
        return callback(new Error("输入不能为空"));
      } else if (value.length > 30) {
        return callback(new Error("不能多于30字"));
      } else {
        callback();
      }
    };
    const validateMobile = (rule, value, callback) => {
      value = value.replace(/\s+/g, "");
      let phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!value) {
        return callback(new Error("输入不能为空"));
      } else if (!phoneReg.test(value)) {
        return callback(new Error("手机格式不正确"));
      } else {
        callback();
      }
    };
    return {
      formDynamic: {
        name: "",
        mobile: "",
        company: "",
        area_list: ""
      },
      ruleValidate: {
        name: [
          { validator: validateContent, trigger: "blur" },
          {
            type: "string",
            max: 20,
            message: "不能多于20字",
            trigger: "blur"
          }
        ],
        mobile: [{ validator: validateMobile, trigger: "blur" }],
        company: [{ validator: validateInfo, trigger: "blur" }]
      },
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "分论坛",
          key: "area_name"
        },
        {
          title: "出品人",
          key: "publisher"
        },
        {
          title: "时间",
          key: "startTime",
          render: (h, params) => {
            return h("span", params.row.date + " " + params.row.time);
          }
        }
      ],
      tableData: [],
      // 选择的表格
      selectedData: [],
      ticketId: "",
      photonNum: 0, //光子数量
      lightShow: false // 控制光子提示组件显示
    };
  },
  computed: {
    ...mapGetters(["user"]),
    changePrice() {
      let this_ = this;
      let result = "";
      if (this_.ticketInfo) {
        result = this_.ticketNum * this_.ticketInfo.price;
      } else {
        result = "";
      }
      return result;
    },
    finallyPrice() {
      let this_ = this;
      let result =
        this_.changePrice - this_.discountCodeValue >= 0
          ? this_.changePrice - this_.discountCodeValue
          : 0;
      return result;
    }
  },
  watch: {
    // 观察光子数量，有变则显示
    photonNum(newVal, oldVal) {
      this.lightShow = true;
    }
  },
  filters: {
    fiMoney(v) {
      let s = Number(v);
      if (isNaN(s)) {
        return "";
      } else {
        return s.toFixed(2);
      }
    }
  },
  created() {
    this.searchAreaList();
    this.checkIsLogin(); //验证是否登陆
  },

  mounted() {
    this.formDynamic.mobile = sessionStorage.getItem("phone") || "";
  },

  methods: {
    //获取分会场信息
    searchAreaList() {
      axios({
        url:
          "/r/cms/www/itn/json/deveConference/signUpList.json?time=" +
          +new Date(),
        method: "get",
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        withCredentials: true
      }).then(res => {
        this.tableData = res.data;
      });
    },

    //报名
    submitPay() {
      this.$refs["formDynamic"].validate(valid => {
        if (valid) {
          this.formDynamic.area_list = this.selectedData;
          onlineSignup({ ...this.formDynamic })
            .then(res => {
              if (res) {
                this.photonNum = res.member_single_point_amount;
                setTimeout(() => {
                  this.$hMessage.success("报名成功！");
                  this.$router.push({ path: "paySuccess" });
                }, 1000);
              }
            })
            .catch(err => {
              log.error(err);
            });
        }
      });
    },

    // 表格方法
    // selectOne(selection, row) {
    //   console.log("选中一条");
    //   console.log(selection);
    // },
    // selectCancel(selection, row) {
    //   console.log("取消一条");
    //   console.log(selection);
    //   console.log(row);
    // },
    // selectAll(selection) {
    //   console.log("全选");
    //   console.log(selection);
    // },
    selectChange(selection) {
      this.selectedData = [];
      selection.forEach(select => {
        this.selectedData.push({
          area_name: select.area_name,
          date: select.date,
          id: select.id,
          publisher: select.publisher,
          time: select.time
        });
      });
    },
    //验证是否登陆
    checkIsLogin() {
      checkLogin().then(res => {
        sessionStorage.setItem("phone", res.phone);
        console.log(res);
      });
    },
    // 关闭光子组件
    onClose() {
      this.lightShow = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.ticketing-service {
  .page-header-banner {
    width: 100%;
    min-width: 1200px;
    height: 465px;
    background: url("../../../assets/developerConference/buy_ticket_banner-big.jpg")
      no-repeat center;
    background-size: cover;
    color: #ffffff;
    .banner-main-content {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      h1 {
        font-family: MicrosoftYaHei-Bold;
        font-size: 44px;
        line-height: 54px;
        padding-top: 183px;
        color: #333333;
        line-height: 54px;
        font-weight: 700;
      }
      p {
        font-family: ArialMT;
        font-size: 28px;
        line-height: 36px;
        color: #ffffff;
        color: #000000;
        text-align: left;
      }
    }
  }
  @media (max-width: 1300px) {
    .page-header-banner {
      height: 378px;
    }
  }
  .ticket-part {
    margin: 0 auto;
    padding-top: 64px;
    width: 1100px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #333333;
    overflow: hidden;
    position: relative;
    .buyer-list {
      width: 100%;
      float: left;
      > div {
        border: 1px solid #d2dbe8;
        border-radius: 3px;
        background: #fff;
        width: 100%;
      }

      .common-info {
        background: #fff;
        margin-bottom: 20px;
        padding: 0 19px;
        .info-title {
          height: 69.5px;
          font-size: 16px;
          color: #000000;
          border-bottom: 1px solid #d2dbe8;
          // padding: 0 13px;
          font-weight: 700;
          line-height: 69px;
        }
      }
      .attendee-info {
        position: relative;
        &:before {
          display: inline-block;
          content: "";
          width: 30px;
          height: 30px;
          background: url("../../../assets/developerConference/corner_icon.png")
            no-repeat center;
          background-size: 100% 100%;
          position: absolute;
          top: 0px;
          left: 0px;
        }
        .corner-num {
          position: absolute;
          top: 1px;
          left: 4px;
          font-family: Arial-BoldMT;
          font-size: 12px;
          color: #ffffff;
        }
      }
      .bougher-info {
        height: 434px;
      }
      .buy-notes {
        // height: 318px;
        padding-bottom: 36px;
        .tips-content {
          color: #000000;
          padding: 19px 13px 0;
          > div {
            line-height: 32px;
            position: relative;
            &:before {
              display: inline-block;
              content: "";
              width: 6px;
              height: 6px;
              background: #1f70fd;
              margin-right: 12px;
              vertical-align: middle;
            }
          }
          > div:nth-child(2n) {
            &:before {
              background: #16d1d0;
            }
          }
          .bill-tips {
            font-family: MicrosoftYaHei;
            color: #666;
          }
        }
        .king-tips-content {
          > div {
            // line-height: 32px;
            // position: relative;
            &:before {
              // display: inline-block;
              // content: '';
              // width: 6px;
              // height: 6px;
              background: #ff5c5c;
              // margin-right: 12px;
              // vertical-align: middle;
            }
          }
          > div:nth-child(2n) {
            &:before {
              background: #e423ff;
            }
          }
        }
      }
      .pay-type {
        height: 434px;
        > div:nth-child(2) {
          padding: 0 13px;
          > div:nth-child(1) {
            padding: 19.5px 0 16px;
          }
          > div:nth-child(2) {
            width: 641px;
            height: 39px;
            // opacity: 0.5;
            background: #f0f4f6;
            font-size: 14px;
            color: #888888;
            line-height: 39px;
            padding-left: 12px;
          }
          .pay-by-Alipay,
          .pay-by-Wechat {
            width: 641px;
            height: 66px;
            border: 1px solid #d2dbe8;
            border-radius: 3px;
            padding: 22px 0 21px 26px;
            margin-top: 18px;
            color: #000000;
            &:before {
              width: 23px;
              height: 23px;
              display: inline-block;
              content: "";
              background: url("../../../assets/developerConference/alipay.png")
                no-repeat center;
              background-size: 100% 100%;
              margin-right: 20px;
              vertical-align: middle;
            }
          }
          .pay-active {
            background: rgba(255, 115, 43, 0.06);
            border: 1px solid #ff732b;
          }
          .pay-by-Wechat:before {
            height: 21px;
            background: url("../../../assets/developerConference/wechart.png")
              no-repeat center;
            background-size: 100% 100%;
          }
          > div:last-child {
            font-size: 12px;
            color: #f4222e;
            padding-left: 13px;
            margin-top: 18px;
          }
        }
      }
      .submit-btn {
        margin: 40px auto 80px;
        height: 52px;
        width: 232px;
        // background: #1f70fd;
        background: url("../../../assets/developerConference/tab_bg.png")
          no-repeat center;
        background-size: 100% 100%;
        font-family: PingFangSC-Semibold;
        color: #fff;
        font-weight: 600;
        border-radius: 4.8px;
        text-align: center;
        line-height: 52px;
        font-size: 18px;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
}
</style>
<style lang="scss">
.ticketing-service .h-form .h-form-item {
  margin-bottom: 16px;
}
.common-info .h-btn {
  color: #fff;
  background-image: linear-gradient(to right, #4646ff 13%, #3ffffe 100%);
}
.ticketing-service .h-form .h-form-item-label {
  font-size: 14px;
  color: #333333;
  padding: 0;
  &:after {
    display: inline-block;
    content: "*";
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #ff1f77;
    letter-spacing: 0.92px;
    margin-left: 4px;
  }
  &:before {
    content: "";
  }
}
#no-star .h-form-item-label {
  &:after {
    display: inline-block;
    content: "";
  }
}
.ticketing-service .h-input-wrapper .h-input {
  height: 36px;
}
.ticketing-service .h-select-single .h-select-selection {
  height: 36px;
}
// .h-modal-content .h-modal-body {
//   background: url('../../../assets/developerConference/msg-bg.png') no-repeat
//     center;
//   background-size: 100% 100%;
// }
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/developerConference/ticketing.vue